import type { ArrayElement, ExamType } from '@evidia/shared';
import { toCzDateString } from '@evidia/shared';
import dayjs from 'dayjs';
import type { RouterOutput } from './trcp';

type ExamDto = ArrayElement<RouterOutput['exam']['exams']>;

export const getExamTry = (
	exms: ExamDto[],
	target: { type: ExamType; studentOnExam: { examId: string; type: ExamType }[]; examId: string },
): number => {
	const exams = exms
		.map(v => ({ ...v, date: dayjs(v.date) }))
		.sort((a, b) => b.date.toDate().getTime() - a.date.toDate().getTime())
		.map(v => ({ ...v, date: toCzDateString(v.date) }));

	const { type, studentOnExam, examId } = target;
	let counter = 0;

	for (let i = exams.length - 1; i >= 0; i--) {
		const exam = exams[i];

		const isMyExam = !!studentOnExam.find(v => v.examId === exam.id && v.type.includes(type));
		if (isMyExam) {
			counter++;
			if (exam.id === examId) {
				break;
			}
		}
	}

	return counter;
};

export const getPrevExam = (
	exams: ExamDto[],
	target: { type: ExamType; studentOnExam: { examId: string; type: ExamType }[] },
): ExamDto | undefined => {
	const { type, studentOnExam } = target;
	let lastExam;

	for (let i = exams.length - 1; i >= 0; i--) {
		const exam = exams[i];

		const typeMatch = exam.type.includes(type);
		const isMyExam = !!studentOnExam.find(v => v.examId === exam.id);
		if (typeMatch && isMyExam) {
			lastExam = exam;
		}
	}

	return lastExam;
};
